import { mediaSlider } from '../../lib/mediaslider/src/mediaslider.bundle.js';

/** @module media */

/**
 * Anzeige von Mediainhalten
 */
export class OpaccMedia {
	constructor() {
		this.carouselThumbContainer = document.querySelectorAll('.opc-carousel[data-op-type="thumb-slider"] .carousel-slides') || null;
		this.carouselHeroContainer = document.querySelectorAll('.opc-carousel[data-op-type="hero-slider"] .carousel-slides') || null;
		this.thumbImages = document.querySelectorAll('.opc-asset li') || null;

		if (this.carouselThumbContainer) {
			Array.from(this.carouselThumbContainer).forEach(item => {
				this.imageThumbCarousel(item);
			});
		}

		if (this.carouselHeroContainer) {
			Array.from(this.carouselHeroContainer).forEach(item => {
				this.imageHeroCarousel(item);
			});
		}

		if (this.thumbImages) {
			Array.from(this.thumbImages).forEach(item => {
				// eslint-disable-next-line no-unused-vars
				item.addEventListener('click', event => {
					this.imageZoom(item);
				});
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	imageThumbCarousel(item) {
		// eslint-disable-next-line no-unused-vars
		let thumbSlider = mediaSlider({
			container: item,
			slideBy: 'page',
			mode: 'carousel',
			items: 1,
			mouseDrag: false,
			touch: true,
			speed: 400,
			navContainer: `#${item.parentElement.id}-thumbnails`,
			navAsThumbnails: true,
			controls: true,
			controlsText: ['','']
		});
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	imageHeroCarousel(item) {
		// eslint-disable-next-line no-unused-vars
		let heroSlider = mediaSlider({
			container: item,
			slideBy: 1,
			mode: 'gallery',
			mouseDrag: false,
			loop: true,
			speed: 1200,
			controls: true,
			controlsText: ['',''],
			navAsThumbnails: false,
			nav: true
		});
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	imageZoom(item) {
		if(item) {
			let mainImage = item.parentElement.previousElementSibling;
			if(mainImage.hasAttribute('src')) {
				let source = item.querySelector('img').getAttribute('src');
				let altern = item.querySelector('img').getAttribute('alt');
				mainImage.setAttribute('src', source);
				mainImage.setAttribute('alt', altern);
				Array.from(item.parentElement.children).forEach(child => {
					child.classList.remove('is-selected');
				});
				item.classList.add('is-selected');
			}
		}
	}
}